import _ from 'lodash';
import FilledInput from '@mui/material/FilledInput';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import { withFormsy } from 'formsy-react';
import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';

function BoolSelectFormsy(props) {
  const { t } = useTranslation('default');
  const importedProps = _.pick(props, [
    'autoWidth',
    'classes',
    'displayEmpty',
    'input',
    'inputProps',
    'MenuProps',
    'multiple',
    'native',
    'onChange',
    'onClose',
    'onOpen',
    'open',
    'renderValue',
    'SelectDisplayProps',
    'value',
    'variant',
    'color',
  ]);

  // An error message is returned only if the component is invalid
  const { errorMessage, value, description } = props;

  function input() {
    switch (importedProps.variant) {
      case 'outlined':
        return <OutlinedInput label={props.label} id={props.name} />;
      case 'filled':
        return <FilledInput id={props.name} />;
      default:
        return <Input id={props.name} />;
    }
  }

  function changeValue(event) {
    props.setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  }

  const helperText = errorMessage || description;

  // https://github.com/mui-org/material-ui/issues/8581#issuecomment-335060574
  return (
    <FormControl
      error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
      className={props.className}
      variant={importedProps.variant}
      disabled={props.disabled}
    >
      {props.label && <InputLabel htmlFor={props.name}>{props.label}</InputLabel>}
      <Select {...importedProps} value={value ?? undefined} onChange={changeValue} input={input()}>
        <MenuItem value={true}>{t('yes')}</MenuItem>
        <MenuItem value={false}>{t('no')}</MenuItem>
      </Select>
      {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default React.memo(withFormsy(BoolSelectFormsy));
